import React from 'react';

import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';

import useTranslation from '../../../features/locale/useTranslation';
import { locales, transformLanguageCode } from '../../../utils';
import { Small } from '../../Typography';

import styles from '../Calendar.module.scss';

type CountdownLabelProps = {
    startDate: Date | null;
    currentLanguage: string | undefined;
};

export const CountdownLabel = ({ startDate, currentLanguage }: CountdownLabelProps) => {
    const { t } = useTranslation();

    if (!startDate) {
        return null;
    }

    return (
        <Small className={styles.countdownLabel} color="secondary">
            {t('{{ time }} left', {
                time: formatDistanceToNowStrict(new Date(startDate), {
                    locale: locales[transformLanguageCode(currentLanguage)]
                })
            })}
        </Small>
    );
};
